import { UserType } from '@/constants';

export interface IToolUserPermissionRow {
    typeId: UserType | null;
    ownerId: number | null;
    openedByToolUserId: number | null;
    companyId?: number | null;
    deletedAt: string | null;
}

export function canEditToolUserRow(item: IToolUserPermissionRow, sessionType: UserType | null, myToolUserId: number | null, isRoot: boolean): boolean {
    if (isRoot) return true;
    if (sessionType == null) return false;
    switch (item.typeId) {
        case UserType.Admin:
        case UserType.Company:
            return sessionType === UserType.Admin;
        case UserType.Agent:
        case UserType.AgentView:
            return sessionType === UserType.Admin || (sessionType === UserType.Company && myToolUserId != null && myToolUserId === item.ownerId);
        case UserType.Player: {
            const agentScopeId = item.ownerId ?? item.openedByToolUserId;
            return (
                sessionType === UserType.Admin ||
                sessionType === UserType.Company ||
                ((sessionType === UserType.Agent || sessionType === UserType.AgentView) && myToolUserId != null && myToolUserId === agentScopeId)
            );
        }
        default:
            return false;
    }
}

export function canDeleteToolUserRow(item: IToolUserPermissionRow, sessionType: UserType | null, myToolUserId: number | null, isRoot: boolean): boolean {
    if (item.deletedAt) return false;
    if (isRoot) return true;
    if (sessionType == null || myToolUserId == null) return false;

    if (sessionType === UserType.Company) {
        switch (item.typeId) {
            case UserType.Agent:
            case UserType.AgentView:
                return myToolUserId === item.ownerId;
            case UserType.Player:
                return item.companyId === myToolUserId && item.ownerId != null && item.ownerId !== myToolUserId;
            default:
                return false;
        }
    }

    return canEditToolUserRow(item, sessionType, myToolUserId, isRoot);
}

export function canToggleSuspiciousToolUserRow(
    item: IToolUserPermissionRow,
    sessionType: UserType | null,
    myToolUserId: number | null,
    isSessionAdmin: boolean
): boolean {
    if (item.typeId !== UserType.Player || item.deletedAt) return false;
    if (isSessionAdmin) return true;
    if (sessionType === UserType.Company) return true;
    if (myToolUserId == null) return false;
    return item.ownerId === myToolUserId || item.companyId === myToolUserId;
}

export function canToggleSuspendedToolUserRow(
    item: IToolUserPermissionRow,
    sessionType: UserType | null,
    myToolUserId: number | null,
    isSessionAdmin: boolean
): boolean {
    if (item.typeId !== UserType.Player || item.deletedAt) return false;
    if (isSessionAdmin) return true;
    if (sessionType === UserType.Company) return true;
    if (myToolUserId == null) return false;
    return item.ownerId === myToolUserId || item.companyId === myToolUserId;
}
